// import React from 'react';
// import './service.css';
// import { motion } from 'framer-motion';
// import sampleImage from '../Asset/about5.png'; // Replace with your image

// function Services() {
//   const serviceList = [
//     {
//       title: "Website Design",
//       description: "Modern, responsive websites tailored to your business.",
//     },
//     {
//       title: "Logo Design",
//       description: "Creative logos to represent your unique brand identity.",
//     },
//     {
//       title: "Poster Design",
//       description: "Eye-catching poster designs for events and promotions.",
//     },
//     {
//       title: "Template Design",
//       description: "Professional templates for presentations and documents.",
//     },
//     {
//       title: "Card Design",
//       description: "Elegant cards for special occasions.",
//     }
//   ];

//   return (
//     <div className="services-page">
//       <div className="animated-bg">
//          <div class="star-layer"></div>
//   <div class="cloud-layer"></div>


// </div>


//       <h1 className="services-title">Our Services</h1>

//       <div className="layout-container">
//         <div className="left-fixed-image">
//           <img src={sampleImage} alt="Side Visual" />
//         </div>

//         <div className="services-container">
//           {serviceList.map((service, index) => (
//             <motion.div
//               key={index}
//               className="service-card"
//               whileHover={{ scale: 1.05 }}
//               transition={{ type: 'spring', stiffness: 200 }}
//             >
//               <h2>{service.title}</h2>
//               <p>{service.description}</p>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Services;



import React from 'react';
import './service.css';
import { motion } from 'framer-motion';
import sampleImage from '../Asset/about5.png';
import { useNavigate } from 'react-router-dom'; // For internal navigation

function Services() {
  const navigate = useNavigate();

  const serviceList = [
    {
      title: "Website Design",
      description: "Modern, responsive websites tailored to your business.",
      link: "/services/website"  // Internal Route
    },
    {
      title: "Logo Design",
      description: "Creative logos to represent your unique brand identity.",
      link: "/services/logo"
    },
    {
      title: "Poster Design",
      description: "Eye-catching poster designs for events and promotions.",
      link: "/services/poster"
    },
    {
      title: "Template Design",
      description: "Professional templates for presentations and documents.",
      link:"/services/template",
    },
    {
      title: "Card Design",
      description: "Elegant cards for special occasions.",
      link: "/services/template"
    }
  ];

  const handleClick = (service) => {
    if (service.external) {
      window.open(service.link, "_blank");  // External website in new tab
    } else {
      navigate(service.link);  // Internal route navigation
    }
  };

  return (
    <div className="services-page">
      <div className="animated-bg">
        <div className="star-layer"></div>
        <div className="cloud-layer"></div>
      </div>

      <h1 className="services-title">Our Services</h1>

      <div className="layout-container">
        <div className="left-fixed-image">
          <img src={sampleImage} alt="Side Visual" />
        </div>

        <div className="services-container">
          {serviceList.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              whileHover={{ scale: 1.05 }}
              transition={{ type: 'spring', stiffness: 200 }}
              onClick={() => handleClick(service)}
              style={{ cursor: "pointer" }}
            >
              <h2>{service.title}</h2>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
